/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PatchDocumentStampedV1Dto = {
  /**
   * The id of the ticket
   */
  ticketId: string;
  /**
   * Cost center of the stamped document
   */
  costCenter: string;
  /**
   * General ledger account
   */
  generalLeaderAccount: string;
  /**
   * General ledger account number
   */
  generalLeaderAccountNr: string;
  /**
   * One-time contribution amount
   */
  oneTimeContribution: number;
  /**
   * Approval number
   */
  approvalNr: string;
  /**
   * Amount
   */
  amount: number;
  /**
   * Interval (e.g., monthly, yearly)
   */
  interval: number;
  /**
   * Indicates if this is a recurring payment
   */
  recurringPayment: boolean;
  /**
   * Indicates if this is a back payment
   */
  backPayment: boolean;
  /**
   * The currency of the payment.
   */
  currency: PatchDocumentStampedV1Dto.currency;
};
export namespace PatchDocumentStampedV1Dto {
  /**
   * The currency of the payment.
   */
  export enum currency {
    EUR = 'EUR',
    ALL = 'ALL',
    AMD = 'AMD',
    AZN = 'AZN',
    BYN = 'BYN',
    BAM = 'BAM',
    CZK = 'CZK',
    DKK = 'DKK',
    GEL = 'GEL',
    GIP = 'GIP',
    GGP = 'GGP',
    HUF = 'HUF',
    ISK = 'ISK',
    IMP = 'IMP',
    JEP = 'JEP',
    KZT = 'KZT',
    CHF = 'CHF',
    MDL = 'MDL',
    MKD = 'MKD',
    NOK = 'NOK',
    PLN = 'PLN',
    RON = 'RON',
    RUB = 'RUB',
    RSD = 'RSD',
    SEK = 'SEK',
    TRY = 'TRY',
    UAH = 'UAH',
    GBP = 'GBP',
  }
}
